import React, { useState } from 'react';
import { Screen } from '../App';
import * as authApi from '../authApi';

interface Props { navigate: (s: Screen) => void; }

export default function ForgotPassword({ navigate }: Props) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handle = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    // Always succeeds from the user's point of view — we never reveal whether
    // an account exists.
    await authApi.requestReset(email.trim()).catch(() => {});
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="page-content" style={{paddingTop:40}}>
      <button onClick={()=>navigate('login')} style={{background:'none',color:'var(--teal)',fontSize:14,marginBottom:24,display:'flex',alignItems:'center',gap:6}}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><polyline points="15,18 9,12 15,6"/></svg>Back to login
      </button>

      {sent ? (
        <div style={{textAlign:'center',marginTop:20}}>
          <p style={{fontSize:40,marginBottom:16}}>📩</p>
          <h1 style={{fontSize:24,marginBottom:12}}>Check your email</h1>
          <p style={{color:'var(--text-secondary)',fontSize:15,lineHeight:1.7}}>
            If an account exists for <strong>{email}</strong>, we've sent a link to reset your password. It expires in 1 hour.
          </p>
          <button onClick={()=>navigate('login')} className="btn-primary" style={{marginTop:24}}>Back to Login</button>
        </div>
      ) : (
        <>
          <div style={{textAlign:'center',marginBottom:32}}>
            <h1 style={{fontSize:28,marginBottom:8}}>Reset your password</h1>
            <p style={{color:'var(--text-secondary)',fontSize:14}}>Enter your email and we'll send you a reset link.</p>
          </div>
          <form onSubmit={handle}>
            <div className="form-group"><label>Email</label><input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="your@email.com"/></div>
            <button type="submit" className="btn-primary" disabled={loading}>{loading?'Sending...':'Send Reset Link'}</button>
          </form>
        </>
      )}
    </div>
  );
}
